import Http from "./../http";

export default {
    // 爱本H5首页 - banner列表
    getBanner(urlParams, params, callback) {
        Http.post(Http.hostName + "/xmh/lucky/content/banner/query", urlParams, params, res => {
            callback(res);
        })
    },
    // 爱本H5首页 - 获取tab标签列表
    getTabList(params, callback) {
        Http.get(Http.hostName + '/xmh/lucky/loveBase/tag/query', params, (res) => {
            callback(res);
        })
    },
    // 爱本H5首页 - 获取内容数据
    getContentData(urlParams, params, callback) {
        Http.post(Http.hostName + "/xmh/lucky/loveBase/content/query", urlParams, params, res => {
            callback(res);
        })
    },
    // 获取雷达图数据
    getSixIconData(params, callback) {
        Http.get(Http.hostName + "/xmh/lucky/spring/rain/radarList", params, res => {
            callback(res);
        })
    },
    // 判断是否定制爱本信息
    isEditAibenMessage(urlParams, params, callback) {
        Http.post(Http.hostName + "/xmh/lucky/newMember/getUserCustomInfo", urlParams, params, res => {
            callback(res);
        })
    },
    // 获取二级分类
    getSecondLevel(params, callback) {
        Http.get(Http.hostName + "/xmh/lucky/eatHealthy/content/queryByTagId", params, res => {
            callback(res);
        })
    }
};
